import React, { useMemo } from 'react';
import { getBibleChooserDataFromString, getStringFromBibleChooserData, type BibleChooserData } from '@soulhx/fs-common';
import { useUserSetting } from '@soulhx/client-store';
import { BibleVersionSearch } from '@soulhx/bible-viewer';

export const FavBibleChooser = () => {
  const { settingValue: defaultVersion, update: updateDefaultVersion } = useUserSetting<string>('readDefaultVersion');
  const chooserData: BibleChooserData[] = useMemo(
    () => getBibleChooserDataFromString(defaultVersion),
    [defaultVersion]
  );

  return (
    <BibleVersionSearch
      chooserData={chooserData}
      update={(newData) => {
        updateDefaultVersion(getStringFromBibleChooserData(newData));
      }}
    />
  );
};
